import React, { Component } from 'react';
import CircularProgress from '@material-ui/core/CircularProgress/CircularProgress';
import Dropzone from 'react-dropzone';
import PropTypes from 'prop-types';

import EditIcon from 'assets/images/edit.png';
import AvatarImage from 'assets/images/no-image.png';
import uploadFileApi from '../utils/FileService';

class FileUpload extends Component {
  constructor(props) {
    super(props);
    this.state = {
      uploadPercent: 0,
      uploadingIcon: false,
    };
  }

  onUploadProgress = (progressEvent) => {
    this.setState({
      uploadPercent: Math.round((progressEvent.loaded * 100) / progressEvent.total),
    });
  };

  uploadFiles = (files) => {
    const { handleChange, client } = this.props;
    const data = new FormData();
    data.append('file', files[0]);

    const uploadConfig = {
      onUploadProgress: this.onUploadProgress,
    };

    this.setState({
      uploadingIcon: true,
    });
    uploadFileApi(data, uploadConfig).then((link) => {
      client ? handleChange(client, link) : handleChange(link);
    }).finally(() => {
      this.setState({
        uploadingIcon: false,
        uploadPercent: 0,
      });
    });
  };

  render() {
    const { uploadingIcon, uploadPercent } = this.state;
    const {
      windowSize, progressSize, editIconSize, editIconPos, editIcon, noImageIcon, image,
    } = this.props;
    return (
      <div className="centered-flex-container" style={{ flexBasis: `${windowSize}px`, overflow: 'hidden' }}>
        {uploadingIcon ? <CircularProgress variant="static" size={progressSize} value={uploadPercent} /> : (
          <Dropzone
            onDrop={this.uploadFiles}
            style={{
              width: `${windowSize}px`, height: `${windowSize}px`, cursor: 'pointer', position: 'relative',
            }}
            className="centered-flex-container"
          >
            <button
              type="button"
              className="no-style-button"
              style={{
                position: 'absolute', padding: 0, top: editIconPos, right: editIconPos,
              }}
            >
              <img src={editIcon} alt="edit" width={editIconSize} height={editIconSize} />
            </button>
            <img src={image || noImageIcon} alt="logo" width={windowSize} height={windowSize} style={{ borderRadius: '50%' }} />
          </Dropzone>
        )}
      </div>
    );
  }
}

FileUpload.propTypes = {
  windowSize: PropTypes.number.isRequired,
  progressSize: PropTypes.number.isRequired,
  editIconSize: PropTypes.number.isRequired,
  editIconPos: PropTypes.number.isRequired,
  image: PropTypes.string.isRequired,
  handleChange: PropTypes.func.isRequired,
  editIcon: PropTypes.string,
  noImageIcon: PropTypes.string,
};

FileUpload.defaultProps = {
  editIcon: EditIcon,
  noImageIcon: AvatarImage,
};


export default FileUpload;



// WEBPACK FOOTER //
// ./src/components/FileUpload.jsx